import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import {SweetSweet_Responsive} from "../SweetSweet/game_responsive";

export class SweetSweetLink_Responsive extends SweetSweet_Responsive {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "SweetSweetLink");
    }

}
